// ============================================================
// data/sciences.ts — Literatura científica que fundamenta o Lume
// ============================================================
// Citações em formato compacto pt-BR. DOI/PMID quando público.
// Ordem cronológica reversa para enfatizar atualidade.
// ============================================================

export interface ScienceReference {
  id: string;
  year: number;
  authors: string;
  title: string;
  journal?: string;
  doi?: string;
  application: string;
}

export const sciences: ReadonlyArray<ScienceReference> = [
  {
    id: 'lewis-stevens-2023',
    year: 2023,
    authors: 'Lewis, L. F.; Stevens, K.',
    title:
      'Identifying autistic adults with experience of clinical research participation: a community survey on gamification.',
    journal: 'Autism in Adulthood',
    doi: '10.1089/aut.2022.0050',
    application:
      'Adultos autistas rejeitam pontos, badges e leaderboards como infantilizantes. O Lume aboliu gamificação clássica em todos os módulos.',
  },
  {
    id: 'botha-2020',
    year: 2020,
    authors: 'Botha, M.; Hanlon, J.; Williams, G. L.',
    title:
      'Does language matter? Identity-first versus person-first language use in autism research.',
    journal: 'Journal of Autism and Developmental Disorders',
    doi: '10.1007/s10803-020-04858-w',
    application:
      'Linguagem identidade-primeiro ("pessoa autista") é a preferência da comunidade. O Lume permite escolha explícita no onboarding.',
  },
  {
    id: 'asan-2020',
    year: 2020,
    authors: 'Autistic Self Advocacy Network (ASAN)',
    title: 'For whose benefit? Evidence, ethics, and effectiveness of autism interventions.',
    application:
      'Princípio "nada sobre nós sem nós" guia todo redesign UX. Conselho consultivo de autistas adultos é obrigatório no programa.',
  },
  {
    id: 'goodwin-2019',
    year: 2019,
    authors: 'Goodwin, M. S.; Mazefsky, C. A.; Ioannidis, S.; Erdogmus, D.; Siegel, M.',
    title:
      'Predicting aggression to others in youth with autism using a wearable biosensor.',
    journal: 'Autism Research',
    doi: '10.1002/aur.2151',
    application:
      'HRV e frequência cardíaca antecipam meltdown em 5–60 minutos. Fundamenta o pipeline wearable + predict on-device com TF.js.',
  },
  {
    id: 'cassidy-2018',
    year: 2018,
    authors: 'Cassidy, S.; Bradley, L.; Shaw, R.; Baron-Cohen, S.',
    title:
      'Risk markers for suicidality in autistic adults.',
    journal: 'Molecular Autism',
    doi: '10.1186/s13229-018-0226-4',
    application:
      'Adultos autistas N1 com camuflagem têm 9× o risco populacional de suicídio. Fundamenta red-team específico do assistantConversation.',
  },
  {
    id: 'constantin-korte-2012',
    year: 2012,
    authors: 'Constantin, A.; Korte, S. M.',
    title: 'Special interests in autism: a meaningful pathway for engagement.',
    application:
      'Interesses focados são via natural de engajamento. O Modo Distração oferece variantes (aves, oceano, árvores, aurora, flores) por preferência.',
  },
  {
    id: 'robertson-2012',
    year: 2012,
    authors: 'Robertson, S. M.',
    title: 'Neurodiversity, quality of life, and autistic adults.',
    journal: 'Disability Studies Quarterly',
    doi: '10.18061/dsq.v30i1.1069',
    application:
      'Autismo é diferença, não déficit. Tom afirmativo permeia toda a copy do Lume — reduzir sofrimento, não "consertar" a pessoa.',
  },
  {
    id: 'mandell-2008',
    year: 2008,
    authors: 'Mandell, D. S.; Morales, K. H.; Marcus, S. C.; Stahmer, A. C.; Doshi, J.; Polsky, D. E.',
    title: 'Psychotropic medication use among Medicaid-enrolled children with autism.',
    journal: 'Pediatrics',
    doi: '10.1542/peds.2008-0984',
    application:
      'Mais de 50% dos pacientes pediátricos com TEA recebem psicotrópicos; 35% recebem 3+. Fundamenta o banco drug-interactions.json em prescrição.',
  },
];
